import RouteTemplate from 'ember-route-template';
import type { GroupInviteLinkRouteModel } from 'invite-sign/routes/group-invite';

interface GroupInviteComponentSignature {
  Args: {
    model: GroupInviteLinkRouteModel;
  };
}

export default RouteTemplate<GroupInviteComponentSignature>(
  <template>
    <style>
    {{#if @model.location.slideUrl}}
        .sidebar-background:after { background-image: url({{@model.location.slideUrl}}); background-size: cover;
        background-position: center; }
      {{/if}}
    .accent { color:
    {{@model.location.buttonColor}}
    !important; } .bg-accent { background-color:
    {{@model.location.buttonColor}}
    !important; } .btn--accent { background:
    {{@model.location.buttonColor}}
    !important; color:
    {{@model.location.buttonTextColor}}; } .btn--accent svg { fill:
    {{@model.location.buttonTextColor}}; } svg.loading-spinner { stroke:
    {{@model.location.buttonTextColor}}; } .underline--accent { border-bottom: 3px solid
    {{@model.location.buttonColor}}; } .btn--accent:hover { background:
    {{@model.location.buttonColor}}; opacity: .8; color:
    {{@model.location.buttonTextColor}}; } .btn--accent:focus { cursor: pointer; outline: none; }
    .btn--accent:active { background:
    {{@model.location.buttonColor}}; color:
    {{@model.location.buttonTextColor}}; } input[type="text"]:focus, input[type="tel"]:focus,
    input[type="email"]:focus, input[type="password"]:focus, input[type="url"]:focus, textarea:focus, select:focus {
    border: 1px solid
    {{@model.location.buttonColor}}; box-shadow: 0 0 3px rgba({{@model.location.buttonColor}},.5);
    transition: all .2s; } a.input.disabled { color: rgb(167,168,173); } a.input.disabled:hover { cursor: pointer; color:
    {{@model.location.buttonColor}}; }
  </style>

    {{outlet}}

    <a class="envoyLogoFooter" href="https://envoy.com/" title="Envoy"></a>
  </template>,
);
